import { Mug as Mug_phosphor } from './Mug.phosphor';
import { Mug as Mug_zoomg } from './Mug.zoomg';
import { Mug as Mug_zoomit } from './Mug.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Mug_zoomg;

    case 'phosphor':
      return Mug_phosphor;

    default:
      return Mug_zoomit;
  }
};

export const Mug = IconRenderer();
